var Flickity = require('flickity');
require('flickity-imagesloaded');

var moduleSlidersCurrent = document.querySelectorAll('.module-slider-current');

for (var i = 0; i < moduleSlidersCurrent.length; i += 1) {
	var moduleSliderCurrent = new Flickity(moduleSlidersCurrent[i], {
		dragThreshold: 50,
		groupCells: true,
		imagesLoaded: true,
		arrowShape: 'M62,76c-0.5,0-1-0.2-1.4-0.6l-24-24c-0.8-0.8-0.8-2,0-2.8l24-24c0.8-0.8,2-0.8,2.8,0c0.8,0.8,0.8,2,0,2.8L40.8,50l22.6,22.6 c0.8,0.8,0.8,2,0,2.8C63,75.8,62.5,76,62,76z'
	});
}


var moduleSlidersPermanent = document.querySelectorAll('.module-slider-permanent');

for (var i = 0; i < moduleSlidersPermanent.length; i += 1) {
	var moduleSlider = new Flickity(moduleSlidersPermanent[i], {
		dragThreshold: 50,
		groupCells: true,
		imagesLoaded: true,
		arrowShape: 'M62,76c-0.5,0-1-0.2-1.4-0.6l-24-24c-0.8-0.8-0.8-2,0-2.8l24-24c0.8-0.8,2-0.8,2.8,0c0.8,0.8,0.8,2,0,2.8L40.8,50l22.6,22.6 c0.8,0.8,0.8,2,0,2.8C63,75.8,62.5,76,62,76z'
	});

}


jQuery(window).bind("load", function() {
	if (window.innerWidth <= 767) {
		var moduleSliders3 = document.querySelectorAll('.module-slider--3');

		for (var i = 0; i < moduleSliders3.length; i += 1) {
			var slider3 = new Flickity(moduleSliders3[i], {
				dragThreshold: 50,
				groupCells: true,
				imagesLoaded: true,
				arrowShape: 'M62,76c-0.5,0-1-0.2-1.4-0.6l-24-24c-0.8-0.8-0.8-2,0-2.8l24-24c0.8-0.8,2-0.8,2.8,0c0.8,0.8,0.8,2,0,2.8L40.8,50l22.6,22.6 c0.8,0.8,0.8,2,0,2.8C63,75.8,62.5,76,62,76z'
			});

			function addFocusSelectHandlerToElem(elem, cellIdx) {
				elem.setAttribute('cellIdx', cellIdx);
				elem.onfocus = function(e) {
					var selectedIndex = e.currentTarget.getAttribute('cellIdx');

					if (selectedIndex) {
						if (selectedIndex === '1') {
							slider3.select(2, false, true);
							window.setTimeout(function() { slider3.select(1, false, true); }, 0);
						}
						else {
							slider3.select(selectedIndex, false, true);
						}
					}
				}
			}

			function addFocusSelectHandlerToElems(elems, cellIdx) {
				for (elemIdx = 0; elemIdx < elems.length; elemIdx += 1) {
					addFocusSelectHandlerToElem(elems[elemIdx], cellIdx);
				}
			}

			// Go through each slider3 cell
			for (cellIdx = 0; cellIdx < slider3.cells.length; cellIdx += 1) {
				addFocusSelectHandlerToElems(
					slider3.cells[cellIdx].element.querySelectorAll('a'),
					cellIdx
					);
			}
		}
	}

});

